import { useState, useEffect, useRef } from "react"
import Tags from "@yaireo/tagify/dist/react.tagify"
import '@yaireo/tagify/dist/tagify.css';
import '../index.scss';

const TagTextInput = (props) => {
    const {
        id,
        SelectCurrentItem,
        // setShowTagItem,
        setChangeTagsData,
        disabled,
    } = props;
    const settings = {
        id: id,
        maxTags: 15, // 限制最大标签数量为15
        disabled: disabled,
    }
    // const [tagifyRef, setTagifyRef] = useState({});
    const [defaultTags, setDefaultTags] = useState('[]');
    // tagify 在 mount 时只绑定一次 onChange，闭包会拿到旧的 defaultTags，所以用 ref 同步最新值
    const lastValueRef = useRef('[]');

    // 把 tag 数组规范化为 ["a","b"] 这样的字符串，便于前后值比较
    const normalize = (v) => {
        try {
            return JSON.stringify((JSON.parse(v || '[]') || []).map(item => item.value));
        } catch (err) {
            return v;
        }
    };

    // on tag add/edit/remove
    const onTagEventChange = (e) => {
        const newValue = e.detail.value || '';
        // Tagify 在失焦时也会触发 onChange，需对比前后值，避免无修改时误触发保存
        if (normalize(newValue) === normalize(lastValueRef.current)) {
            return;
        }
        lastValueRef.current = newValue;
        setDefaultTags(newValue);
        setChangeTagsData(e.detail.tagify.getCleanValue(), id);
    }

    // 设置tag
    const setTagsData = (data) => {
        let tags = '';
        data.forEach((item, index) => {
            if (index === data.length - 1) {
                tags += `{"value":"${item}"}`;
            } else {
                tags += `{"value":"${item}"},`;
            }
        })
        const next = `[${tags}]`;
        lastValueRef.current = next;
        setDefaultTags(next);
    }

    useEffect(() => {
        const selArr = SelectCurrentItem || [];
        // 父组件回写同一批 tag 时不要重置 Tagify，避免编辑过程中 loadOriginalValues 打乱 selection
        try {
            if (JSON.stringify(selArr) === normalize(lastValueRef.current)) {
                return;
            }
        } catch (err) {}
        setTagsData(selArr);
    }, [id, SelectCurrentItem])

    return (
        <div id={`Tagify-${id}_Input`}>
            <Tags
                // tagifyRef={tagifyRef} // optional Ref object for the Tagify instance itself, to get access to  inner-methods
                settings={settings}  // tagify settings object
                onChange={onTagEventChange}
                value={defaultTags}
                disabled={disabled}
            />
        </div>
    )
}

export default TagTextInput
